<form [formGroup]='addressForm'>
    <nb-card status="info">
        <nb-card-header>
            <div class="row">
                <div class="col-sm-12 col-md-7">
                    {{title}}
                </div>
                <div class="col-sm-12 col-md-5" [ngClass]="{'same-address-as': showUseAddressAsCheckBox}">
                    <ngx-ggAutocomplete
                        *ngIf="!showUseAddressAsCheckBox && !addressForm.controls.sameAddressAs?.value && !addressForm.disabled"
                        type="address" (onLocationSelected)="onLocationSelected($event)">
                    </ngx-ggAutocomplete>
                    <nb-checkbox *ngIf="showUseAddressAsCheckBox" status="basic" formControlName="sameAddressAs"
                        (checkedChange)="onSameAsOtherAddressChecked($event)">
                        {{useAddressAsLabel}}
                    </nb-checkbox>
                </div>
            </div>
        </nb-card-header>
        <nb-card-body *ngIf="!addressForm.controls.sameAddressAs?.value">
            <div class="row">
                <div class="col-sm-6">
                    <ngx-input-text label="Address 1" placeholder=""
                        [control]="addressForm.controls.address1" controlName="address1" [required]="true">
                    </ngx-input-text>
                    <ngx-input-text label="Address 2" placeholder=""
                        [control]="addressForm.controls.address2" controlName="address2">
                    </ngx-input-text>
                    <ngx-input-text label="City" placeholder=""
                        [control]="addressForm.controls.city" controlName="city" [required]="true">
                    </ngx-input-text>
                    <ngx-input-text label="State" placeholder=""
                        [control]="addressForm.controls.state" controlName="state" [required]="true">
                    </ngx-input-text>
                    <ngx-input-text label="Zip Code" placeholder=""
                        [control]="addressForm.controls.zipCode" controlName="zipCode" [required]="true">
                    </ngx-input-text>
                    <div class="form-group">
                        <div class="row">
                            <label class="col-sm-3 col-form-label">
                                Region
                            </label>
                            <div class="col-sm-9">
                                <ngx-select [control]="addressForm.controls.regionId" [list]="regionDropDown"></ngx-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</form>

